export default __webpack_public_path__ + "static/media/kocek_black_small_logo.b105cd4e.svg";